import {hotmathsContent} from './hotmaths';
import {southAfricaContent} from './southafrica';
import {indiaContent} from './india';
import {lantiteContent} from './lantite';
import {edjinContent} from './edjin';

/**
 * Homepage copy by brand code.
 *
 * The JSP that mounts the page names its brand in `data-brand-code`, so the right copy is there on first
 * render - waiting for `/web/ui/home/public/config` would flash the HOTmaths page on every other brand.
 */
const CONTENT_BY_BRAND = {
    HOTMATHS: hotmathsContent,
    SOUTH_AFRICA: southAfricaContent,
    INDIA: indiaContent,
    NUMERACY: lantiteContent,
    EDJIN: edjinContent,
};

export function contentForBrand(brandCode) {
    return CONTENT_BY_BRAND[brandCode] || hotmathsContent;
}
